const transformDateString = data => {
  const date = new Date(data);
  return data ? `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}` : '';
};

export default transformDateString;